var React = require('react');

function Offer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":0}),React.createElement("path",{"fill":"currentColor","d":"M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z","key":1}),React.createElement("circle",{"fill":"currentColor","cx":"6.5","cy":"6.5","r":"1.5","key":2})]);
}

Offer.defaultProps = {"width":"24","height":"24","viewBox":"-5 -5 34 34"};

module.exports = Offer;

Offer.default = Offer;
